import Image from 'next/image';

import { ArrowRight } from '@/icons/index';

import Button from '../Button/Button';

import styles from './BannerWithForegroundImage.module.scss';

const BannerWithForegroundImage = ({
  item,
  onClick,
  buttonText,
  href,
  buttonHide,
}) => {
  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.banner}>
        <div className={styles.content}>
          {item.title && <h3 className={styles.title}>{item.title}</h3>}
          <p className={styles.text}>{item.text}</p>
          {!buttonHide && (
            <Button
              href={href}
              Component={href ? 'router' : 'button'}
              onClick={onClick}
              variant={'white'}
              className={styles.button}
            >
              {buttonText || item?.buttonText}
              <ArrowRight width={20} />
            </Button>
          )}
        </div>
        <div className={styles.imageContainer}>
          <Image
            src={item.image}
            layout={'fill'}
            className={styles.image}
            alt={item.text}
            title={item.text}
            loading='lazy'
          />
        </div>
      </div>
    </div>
  );
};

export default BannerWithForegroundImage;
